export default "__VITE_ASSET__pKF3zc6G__"